import { useState, useEffect } from "react";
import React from "react";
import Header from "../../components/shared/Layout/Header";
import API from "./../../services/API";
import moment from "moment";
const Analytics = () => {
  const [data, setData] = useState([]);
  const [inventoryData, setInventoryData] = useState([]); //inventory data
  // GET BLOOD DATA RECORDS
  // to set the color
  const colors = [
    "#A0C49D",
    "#C4D7B2",
    "#E1ECC8",
    "#F7FFE5",
    "#F5F0BB",
    "#DBDFAA",
    "#B3C890",
    "#A0D8B3",
  ];
  const getBloodGroupData = async () => {
    try {
      const { data } = await API.get("/analytics/bloodgroups-data");
      if (data?.success) {
        setData(data?.bloodGroupData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //get the data
  useEffect(() => {
    getBloodGroupData();
  }, []);

  //get the record function
  const getBloodRecord = async () => {
    try {
      const { data } = await API.get("/inventory/get-recent-inventory");
      if (data?.success) {
        setInventoryData(data?.inventory);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getBloodRecord();
  }, []);

  return (
    <>
      <Header />
      <div className="d-flex flex-row flex-wrap">
        {data?.map((record, i) => (
          <div
            className="card m-2 p-1"
            key={i}
            style={{ width: "18rem", backgroundColor: `${colors[i]}` }}
          >
            <div className="card-body">
              <h1 className="card-title bg-light text-dark text-center mb-3">
                {record.bloodGroup}
              </h1>
              <p className="card-text">
                Total In:<b> {record.totalIn}</b>(ML)
              </p>
              <p className="card-text">
                Total Out:<b> {record.totalOut}</b>(ML)
              </p>
            </div>
            <div className="card-footer text-light bg-dark text-center">
              Total Available:<b> {record.avalilableBlood}</b>(ML)
            </div>
          </div>
        ))}
      </div>
      <div className="container mt-3">
        <h1 className="my-3">Recent Blood Transactions</h1>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">Blood Group</th>
              <th scope="col">Inventory Type</th>
              <th scope="col">Quantity</th>
              <th scope="col">Donar Email</th>
              <th scope="col">Time and Date</th>
            </tr>
          </thead>
          <tbody>
            {inventoryData?.map((record) => (
              <tr key={record._id}>
                <td>{record.bloodGroup}</td>
                <td>{record.inventoryType}</td>
                <td>{record.quantity} (ML)</td>
                <td>{record.email}</td>
                <td>{moment(record.createdAt).format("DD/MM/YYYY hh:mm A")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Analytics;
